import React, { Component } from 'react';
import Layout from "./containers/Layout/Layout";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "./axios"

// Administration
import Customers    from "./components/1-administration/1-customers/customers";
import Sales        from "./components/1-administration/2-sales/sales";
import Purchases    from "./components/1-administration/3-purchases/purchases";
import FinBookings  from "./components/1-administration/4-bookings/bookings";
import Financial    from "./components/1-administration/5-financial/financial";
import Cashout      from "./components/1-administration/6-cashout/cashout";

import SalesOverview  from "./components/2-sales/1-overview/overview";
import Orders         from "./components/2-sales/2-orders/orders";
import Deals          from "./components/2-sales/3-deals/deals";

// Stock
import StockOverview    from "./components/3-stock/1-overview/overview";
import StockBookings    from "./components/3-stock/2-bookings/bookings";
import Catalog          from "./components/3-stock/3-parts catalog/parts catalog";
import InUse            from "./components/3-stock/4-parts in use/parts in use";

// Deployments
import Fleet      from "./components/4-deployments/fleet/fleet";
import Licenses   from "./components/4-deployments/licenses/licenses";
import Statistics from "./components/4-deployments/statistics/statistics";

// Infrastructure
import Server   from "./components/5-infrastructure/server/server";
import Downloads from "./components/5-infrastructure/downloads/downloads";
import Decoders from "./components/5-infrastructure/decoders/decoders";
import Images   from "./components/5-infrastructure/images/images";

// Platforms
import Accounts  from "./components/6-platforms/accounts/accounts";
import Companies from "./components/6-platforms/companies/companies";
import Devices   from "./components/6-platforms/devices/devices";
import Shop      from "./components/6-platforms/shop/shop";

// Authentication
import ResetPassword from "./components/authentication/ResetPassword/ResetPassword";

import * as actions from "./store/actions/auth";
import * as privilegeActions from "./store/actions/privilege"

class App extends Component {


  componentDidMount() {
    // Try to restore session
    this.props.attemptSessionRestoration()

    // Check frontend privileges
    axios.get("/auth/privileges")
      .then(response => {
        this.props.updatePrivileges(response.data)
      }
    )
  }

  render() {

    // Redirect if necessary
    let redirect = null;
    // If not authenticated
    if (this.props.isAuthenticated === false && this.props.history.location.pathname !== "/" && this.props.history.location.pathname !== "/reset-password") {
      redirect = (<Redirect to="/"/>);
    }
    // If authenticated
    if (this.props.isAuthenticated === true && this.props.history.location.pathname === "/") {
      redirect = (<Redirect to="/infrastructure/server"/>);
    }

    return (
      <div className="App">
        <Switch>
          {/* Public route - outside Layout, no auth required */}
          <Route exact path="/reset-password" component={ResetPassword}></Route>

          {/* All other routes inside Layout - auth required */}
          <Route path="/">
        <Layout
            isAuthenticated={this.props.isAuthenticated}
            username={this.props.username}
            logout={this.props.logout}
            enableAdministation={this.props.hasAdministrationPrivilege}
            enableSales={this.props.hasSalesPrivilege}
            enableStock={this.props.hasStockPrivilege}
            enableDeployments={this.props.hasDeploymentPrivilege}
            enableInfrastructure={this.props.hasInfrastructurePrivilege}
            enablePlatforms={this.props.hasUserManagementPrivilege}
            enableDeviceLogistics={this.props.hasDeviceLogisticsPrivilege}>

          <Switch>
            <Route path="/administration/customers" component={Customers}></Route>
            <Route path="/administration/sales" component={Sales}></Route>
            <Route path="/administration/purchases" component={Purchases}></Route>
            <Route path="/administration/bookings" component={FinBookings}></Route>
            <Route path="/administration/financial" component={Financial}></Route>
            <Route path="/administration/cashout" component={Cashout}></Route>
            <Route path="/sales/overview" component={SalesOverview}></Route>
            <Route path="/sales/orders" component={Orders}></Route>
            <Route path="/sales/deals" component={Deals}></Route>

            <Route path="/stock/overview" component={StockOverview}></Route>
            <Route path="/stock/bookings" component={StockBookings}></Route>
            <Route path="/stock/catalog" component={Catalog}></Route>
            <Route path="/stock/in-use" component={InUse}></Route>

            <Route path="/deployments/edit" component={Fleet}></Route>
            <Route path="/deployments/licenses" component={Licenses}></Route>
            <Route path="/deployments/statistics" component={Statistics}></Route>

            <Route path="/infrastructure/server" component={Server}></Route>
            <Route path="/infrastructure/downloads" component={Downloads}></Route>
            <Route path="/infrastructure/decoders" component={Decoders}></Route>
            <Route path="/infrastructure/images" component={Images}></Route>

            <Route path="/platforms/accounts" component={Accounts}></Route>
            <Route path="/platforms/companies" component={Companies}></Route>
            {this.props.hasDeviceLogisticsPrivilege && (
              <Route path="/platforms/devices" component={Devices}></Route>
            )}
            <Route path="/platforms/shop" component={Shop}></Route>
          </Switch>
        </Layout>
          </Route>
        </Switch>
        {redirect}
      </div>
    );
  }
}


// MARK: - Redux

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    username: state.auth.username,
    hasAdministrationPrivilege: state.privilege.hasAdministrationPrivilege,
    hasSalesPrivilege: state.privilege.hasSalesPrivilege,
    hasStockPrivilege: state.privilege.hasStockPrivilege,
    hasDeploymentPrivilege: state.privilege.hasDeploymentPrivilege,
    hasInfrastructurePrivilege: state.privilege.hasInfrastructurePrivilege,
    hasUserManagementPrivilege: state.privilege.hasUserManagementPrivilege,
    hasDeviceLogisticsPrivilege: state.privilege.hasDeviceLogisticsPrivilege
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    attemptSessionRestoration: () => dispatch(actions.attemptSessionRestoration()),
    updatePrivileges: (list) => dispatch(privilegeActions.updatePrivileges(list)),
    logout: () => dispatch(actions.logout())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
